var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-button",on:{"click":_vm.displayAbout}},[_c('img',{attrs:{"src":require('../assets/o_projekcie.svg')}}),_c('span',[_vm._v("o mapie")])])}
var staticRenderFns = []

export { render, staticRenderFns }